module.exports = __webpack_public_path__ + "img/company-logo.28502ac1.png";